import Image from "next/image";
import Link from "next/link";

import type { NextPageWithProps } from "~/types";

const links = [
	{
		href: "https://www.laptboard.org/assets/docs/Forms/Attendee_Course_Approval_Application.pdf",
		title: "Louisiana (LA)",
	},
	{
		href: "https://health.maryland.gov/bphte/Pages/education.aspx#license",
		title: "Maryland (MD)",
	},
	{
		href: "https://ptboard.nv.gov/FAQ/FAQ/",
		title: "Nevada (NV)",
	},
	{
		href: "https://www.njconsumeraffairs.gov/pt/Pages/FAQ.aspx",
		title: "New Jersey (NJ) – Only if audited",
	},
	{
		href: "https://portalopta.cyzap.net/dzapps/dbzap.bin/apps/assess/webmembers/login?webid=OPTA",
		title: "Ohio (OH)",
	},
	{
		href: "http://www.wvbopt.com/documents/Instructions-App%20CE%20Form%20C%201101171.pdf",
		title: "West Virginia (WV)",
	},
	{
		href: "https://mn.gov/boards/physical-therapy/license/continuingeducation/new-requirements/",
		title: "Minnesota (MN)",
	},
	{
		href: "https://ceulocker.com/",
		title: "New Mexico (NM)",
	},
	{
		href: "https://cebroker.com/plans/pro-plus?state=5&",
		title: "Tennessee (TN)",
	},
];

const PhysicalTherapistsUSPage: NextPageWithProps = () => {
	return (
		<main className="m-auto flex max-w-7xl flex-col items-center gap-5 px-6 py-12">
			<h1 className="text-4xl">Physcial Therapists US</h1>

			<Image
				width={1000}
				height={800}
				className="rounded-lg shadow-xl"
				src={`${process.env.NEXT_PUBLIC_VERCEL_STORAGE_URL}/physical-therapists-us-map.svg`}
				alt="Physical Therapists Map of US"
				unoptimized
			/>

			<section className="as col-start-1">
				<h2 className="mb-2 text-xl">
					For More information on petitioning for credit, click on the links
					below:
				</h2>

				<ul className="list-inside list-decimal text-lg">
					{links.map((link) => (
						<li key={link.href}>
							<Link
								className="text-sky-600/90 hover:underline"
								href={link.href}
								target="_blank"
								rel="noopener noreferrer"
							>
								{link.title}
							</Link>
						</li>
					))}
				</ul>
			</section>
		</main>
	);
};

export default PhysicalTherapistsUSPage;
